enum AvatarEnum {
  // K-5
  JOE = "svg:Joe"
}
export default AvatarEnum;
